import React from 'react';
import { Container, ContainerPayment, ContainerPaymentItem, ContainerPaymentMethods, ContainerPayments, ContainerTitle, ItemPayment } from "../styles";
import PaymentCreate from '../PaymentCreate';
import { useSelector } from 'react-redux';
import { StoreState } from '../../../store/createStore';
import Loading from '../../Loading';
import { useTranslation } from '../../../hooks/useTranslation';
import { ReactCreditCardProps } from '../../../store/modules/auth/types';
import { MethodsProps } from '../../../store/modules/parameter/types';

interface PaymentCreateTypeProps {
  values: ReactCreditCardProps;
  methodSelected: MethodsProps;
  handledSetMethod: (methodSel: MethodsProps) => void;
  onSetOpenViewCreatePayment: () => void;
}

const PaymentCreateType = ({
    onSetOpenViewCreatePayment,
    handledSetMethod,
    methodSelected,
    values,
}: PaymentCreateTypeProps) => {
  const { onTranslation: t } = useTranslation();
  const { methodsAll, methodsType, loading } = useSelector((state: StoreState) => state.parameter);

  if (loading) {
    return (
      <Container bJustifyContentCenter>
        <Loading size={160} bShowText />
      </Container>
    )
  }

  if (methodSelected.media_id !== undefined && methodSelected.media_id !== 0) {
    return (
      <Container>
        <PaymentCreate
          onSetOpenViewCreatePayment={onSetOpenViewCreatePayment}
          handledSetMethod={handledSetMethod}
          valuesEdit={values}
          methodSelected={methodSelected}
        />
      </Container>
    )
  }

  return (
    <Container>
      <ContainerPayments>
        <ContainerTitle>
          <h3>{t('main.component_account_payment.method_payment')}</h3>
          <span>{t('main.component_account_payment.method_enable')}</span>
        </ContainerTitle>

        <ContainerPayment>
          <ContainerPaymentItem>
            <ContainerPaymentMethods>
              {methodsAll && methodsAll.map((method, index) => (
                <ItemPayment id={`method-${index}`} key={method.media_id} onClick={() => handledSetMethod(method)}>
                  <span>{method.name}</span>
                </ItemPayment>
              ))}
              {methodsType.options.cards.length > 0 && methodsType.options.cards.map((method, index) => (
                <ItemPayment id={`method-${index}`} key={method.media_id} onClick={() => handledSetMethod(method)}>
                  <span>{method.name}</span>
                </ItemPayment>
              ))}
            </ContainerPaymentMethods>
          </ContainerPaymentItem>
        </ContainerPayment>
      </ContainerPayments>
    </Container>
  )

}

export default PaymentCreateType;